// extracted by mini-css-extract-plugin
module.exports = {"more":"style_more__1coM9","number":"style_number__3KbyC"};